import { RouteRecordRaw } from 'vue-router';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/profile',
    name: 'MyProfileView',
    component: () => import('@/components/pages/profile/MyProfileView.vue'),
    meta: {
      noHeader: true,
      layout: 'list',
    }
  },
  {
    path: '/profile/edit',
    name: 'EditProfileView',
    component: () => import('@/components/pages/profile/EditProfileView.vue'),
    meta: {
      layout: 'blank',
    }
  },
  {
    path: '/profile/change/auth/:stage',
    name: 'ChangeAuthPwdView',
    component: () => import('@/components/pages/profile/ChangeAuthPwdView.vue'),
    meta: {
      layout: 'blank',
      back: { name: 'MyProfileView' }
    }
  },
  {
    path: '/profile/auth/2step',
    name: '2StepAuthView',
    component: () => import('@/components/pages/profile/2StepAuthView.vue'),
    meta: {
      layout: 'blank',
      back: { name: 'MyProfileView' }
    }
  },
  {
    path: '/profile/orders',
    name: 'MyOrderListView',
    component: () => import('@/components/pages/profile/MyOrderListView.vue'),
    meta: {
      layout: 'blank',
      back: { name: 'MyProfileView' }
    }
  },
  {
    path: '/profile/orders/edit/:id',
    name: 'OrderInfoEditView',
    component: () => import('@/components/pages/profile/my_trst/OrderInfoEditView.vue'),
    meta: {
      layout: 'blank',
    }
  },
  {
    path: '/profile/orders/:id',
    name: 'MyOrderDetailView',
    component: () => import('@/components/pages/profile/MyOrderDetailView.vue'),
    meta: {
      layout: 'blank',
      back: { name: 'MyOrderListView' }
    }
  },
];

export default routes
